import React from "react";
import { useTranslation } from "react-i18next";
import { Icon, Input } from "semantic-ui-react";

import "components/UploadVideo/UploadVideo.scss";
import { useUploadAttachment } from "hooks";
import { clickOnId, isFileWithinSizeLimit } from "utils/common";

type UploadVideoProps = {
  path: string;
  baseURL: string;
  uploadPath: string;
  onSuccess?: (url: string) => void;
  onError?: (reason: string) => void;
  formId: string;
};

export const UploadVideo = ({ path, baseURL, uploadPath, onSuccess, onError, formId }: UploadVideoProps) => {
  const { t } = useTranslation();

  const { handleUploadFileAttachment } = useUploadAttachment(path, baseURL);

  const handleChangeFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const uploadFile = event.target.files?.[0];
    event.target.value = "";
    if (!uploadFile || !isFileWithinSizeLimit(uploadFile, t)) return;

    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("path", uploadPath);

    try {
      const attachmentUrl = await handleUploadFileAttachment({ formData });

      if (attachmentUrl) onSuccess?.(attachmentUrl);
      else throw new Error(t("v8_something_went_wrong", "Something went wrong, please contact the administrator."));
    } catch (e: Error | unknown) {
      const errMessage = e instanceof Error ? e.message : t("v8_something_went_wrong", "Something went wrong, please contact the administrator.");
      if (onError) onError(errMessage);
    }
  };

  return (
    <div className="upload-container">
      <Icon className="upload blue" onClick={() => clickOnId(formId)} />
      <Input id={formId} accept="video/mp4, video/quicktime" type="file" onChange={handleChangeFile} />
    </div>
  );
};
